import { createContext, useContext, useMemo,useState } from 'react';

import { ALLOWED_CONTENT_LANGUAGES, ALLOWED_INTERFACE_LANGUAGES, DEFAULT_LANGUAGE, LANGUAGES, LS_LNG_CONTENT, LS_LNG_INTERFACE } from '../config';
import i18n from '../i18n';

const parseContentLanguages = (values = []) => {
  let newValue = ALLOWED_CONTENT_LANGUAGES.filter((allowed) => values.includes(allowed));
  if (newValue.length === 0) {
    newValue = ALLOWED_CONTENT_LANGUAGES;
  }
  return newValue;
};

const parseInterfaceLanguage = (value = '') => {
  return ALLOWED_INTERFACE_LANGUAGES.includes(value) ? value : DEFAULT_LANGUAGE;
};

const browserLanguage = (navigator?.language || DEFAULT_LANGUAGE).split('-')[0];
const currentContentLanguages = () => parseContentLanguages(localStorage.getItem(LS_LNG_CONTENT) ? JSON.parse(localStorage.getItem(LS_LNG_CONTENT)) : [browserLanguage]);
const currentInterfaceLanguage = () => parseInterfaceLanguage(localStorage.getItem(LS_LNG_INTERFACE) || browserLanguage);

const defaultState = {
  currentContentLanguages: currentContentLanguages(),
  currentInterfaceLanguage: currentInterfaceLanguage(),
};

export const LanguageContext = createContext({
  ...defaultState,
  actions: {
    setCurrentContentLanguages() {},
    setCurrentInterfaceLanguage() {},
  },
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [currentContentLanguages, setCurrentContentLanguages] = useState(defaultState.currentContentLanguages);
  const [currentInterfaceLanguage, setCurrentInterfaceLanguage] = useState(defaultState.currentInterfaceLanguage);

  const handleCurrentContentLanguagesChange = async (values) => {
    const newValue = parseContentLanguages(values);
    setCurrentContentLanguages(newValue);
    localStorage.setItem(LS_LNG_CONTENT, JSON.stringify(newValue));
  };

  const handleCurrentInterfaceLanguageChange = async (value) => {
    const newValue = parseInterfaceLanguage(value);
    setCurrentInterfaceLanguage(newValue);
    localStorage.setItem(LS_LNG_INTERFACE, newValue);
    return i18n.changeLanguage(newValue);
  };

  const actions = useMemo(
    () => ({
      setCurrentContentLanguages: handleCurrentContentLanguagesChange,
      setCurrentInterfaceLanguage: handleCurrentInterfaceLanguageChange,
    }),
    []
  );
  return <LanguageContext.Provider value={{ currentContentLanguages, currentInterfaceLanguage, actions }}>{children}</LanguageContext.Provider>;
};

export const getCurrentContentLanguages = currentContentLanguages;
export const getCurrentInterfaceLanguage = currentInterfaceLanguage;

export const getContentLanguagesValues = () => LANGUAGES.filter((l) => ALLOWED_CONTENT_LANGUAGES.includes(l.value));
export const getInterfaceLanguagesValues = () => LANGUAGES.filter((l) => ALLOWED_INTERFACE_LANGUAGES.includes(l.value));
